import productImpression from '../upgrade/schemaProductImpression';
import productClick from '../upgrade/schemaProductClick';
import mybPurchase from '../upgrade/schemaMYBPurchase';

export default {
  mybPurchase,
  productClick,
  productImpression,
};
